import enquireJs from 'enquire.js'

export default function (callback) {
    var type = ''
    enquireJs.register('screen and (max-width: 660px)', {
        match: () => {
            type = 'mobile'
            callback && callback(type)
        }
    }).register('screen and (min-width: 660px) and (max-width: 1199px)', {
        match: () => {
            type = 'tablet'
            callback && callback(type)
        }
    }).register('screen and (min-width: 1200px)', {
        match: () => {
            type = 'desktop'
            callback && callback(type)
        }
    })
}
